
export const AUTH_LOGIN_PATH = `/login`
export const AUTH_LOGOUT_PATH = `/logout`
export const AUTH_VERIFICATION_PATH = `/verify`
export const AUTH_DRIVER_VERIFICATION_PATH = `/verifydriver`
